module.exports = __webpack_public_path__ + "static/img/news_29.0ff73d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_29.png
// module id = blX4
// module chunks = 2